import { render } from "./ImageAside.vue?vue&type=template&id=1ea039a6&scoped=true"
import script from "./ImageAside.vue?vue&type=script&lang=js"
export * from "./ImageAside.vue?vue&type=script&lang=js"

import "./ImageAside.vue?vue&type=style&index=0&id=1ea039a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ea039a6"

export default script